
import { Vue, Component } from 'vue-property-decorator'
import util from '@/utils/busi/util'
import dayjs from 'dayjs'
import { LocalStorage } from '@/utils/storage'

@Component({
  name: 'member-detail'
})

export default class MemberDetail extends Vue {
  private dayjs = dayjs
  private onBack () {
    localStorage.setItem('routerParams', '')
    this.$router.push({
      name: 'customerCenter'
    })
  }

  private params: any = {}

  beforeMount () {
    const userType = LocalStorage.getObj('user_info_key').userType
    this.params = util.getRouterParams()
    if (userType === 3) {
      this.params.userName = this.params.userName ? this.params.userName.substring(0, 5) + '******' : ''
      this.params.userAccount = this.params.userAccount ? this.params.userAccount.substring(0, 5) + '******' : ''
      this.params.phone = this.params.phone ? this.params.phone.substring(0, 5) + '******' : ''
    }
  }
}
